/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  IndustryTaxonomy,
  IndustryTaxonomy$inboundSchema,
  IndustryTaxonomy$Outbound,
  IndustryTaxonomy$outboundSchema,
} from "./industrytaxonomy.js";

export type EnrichedIndustries = {
  industries: Array<IndustryTaxonomy>;
};

/** @internal */
export const EnrichedIndustries$inboundSchema: z.ZodType<
  EnrichedIndustries,
  z.ZodTypeDef,
  unknown
> = z.object({
  industries: z.array(IndustryTaxonomy$inboundSchema),
});
/** @internal */
export type EnrichedIndustries$Outbound = {
  industries: Array<IndustryTaxonomy$Outbound>;
};

/** @internal */
export const EnrichedIndustries$outboundSchema: z.ZodType<
  EnrichedIndustries$Outbound,
  z.ZodTypeDef,
  EnrichedIndustries
> = z.object({
  industries: z.array(IndustryTaxonomy$outboundSchema),
});

export function enrichedIndustriesToJSON(
  enrichedIndustries: EnrichedIndustries,
): string {
  return JSON.stringify(
    EnrichedIndustries$outboundSchema.parse(enrichedIndustries),
  );
}
export function enrichedIndustriesFromJSON(
  jsonString: string,
): SafeParseResult<EnrichedIndustries, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EnrichedIndustries$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EnrichedIndustries' from JSON`,
  );
}
